import React from "react";
import YouTube from "react-youtube";

const Player = ({ videoId, options, autoplay = 1, ...props }) => {
  const opts = {
    height: "100%",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay,
      mute: 0,
    },
    ...options,
  };

  return (
    <YouTube
      containerClassName="overflow-hidden pb-[56.25%] relative h-0"
      className="left-0 top-0 h-full w-full absolute"
      videoId={videoId}
      opts={opts}
      {...props}
    />
  );
};

const PlayerComponent = React.memo(Player);

export default PlayerComponent;
